import { Typography, Box } from '@mui/material';
import { forwardRef } from 'react';
import { StyledBaseButton } from './BaseButton.style';

export enum BASE_BUTTON_VARIANT {
  FILLED = 'filled',
  OUTLINED = 'outlined',
  GHOST = 'ghost',
}

export enum BASE_BUTTON_COLOR {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  INHERIT = 'inherit',
  SUCCESS = 'success',
  ERROR = 'error',
  WHITE = '#212B36',
  DOWNLOAD = 'download',
  CONTINUE = 'continue',
  INFO = 'info',
}

type TProp = {
  variant: BASE_BUTTON_VARIANT;
  color: BASE_BUTTON_COLOR;
  text: string;
  icon?: JSX.Element;
  onClick?: () => void;
  width?: string;
  style?: Record<string, string>;
};

type TRef = HTMLButtonElement;

export const BaseButton = forwardRef<TRef, TProp>(
  function BaseButton(props, ref) {
    const { onClick, variant, color, icon, text, width, style } = props;
    return (
      <StyledBaseButton
        onClick={onClick}
        variant={
          variant === BASE_BUTTON_VARIANT.FILLED ? 'contained' : 'outlined'
        }
        width={width}
        ref={ref}
        buttonColor={color}
        buttonVariant={variant}
        sx={style}
      >
        {icon && <Box sx={{ display: 'flex' }}>{icon}</Box>}
        {text && (
          <Typography fontSize="inherit" fontWeight="inherit">
            {text}
          </Typography>
        )}
      </StyledBaseButton>
    );
  },
);
